/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Overlap_LabelInputs */

const en_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlap Detection`)
};

const fr_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détection des chevauchements`)
};

const de_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappungserkennung`)
};

const it_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevamento sovrapposizione`)
};

const ru_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение перекрытия`)
};

const es_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detección de superposición`)
};

const zh_cn2_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重叠检测`)
};

const ja_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複検出`)
};

const hi_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरलैप डिटेक्शन`)
};

const pt_pt2_edit_event_group_overlap_label = /** @type {(inputs: Edit_Event_Group_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecção de sobreposição`)
};

/**
* | output |
* | --- |
* | "Overlap Detection" |
*
* @param {Edit_Event_Group_Overlap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_overlap_label = /** @type {((inputs?: Edit_Event_Group_Overlap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Overlap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_overlap_label(inputs)
	if (locale === "de") return de_edit_event_group_overlap_label(inputs)
	if (locale === "it") return it_edit_event_group_overlap_label(inputs)
	if (locale === "ru") return ru_edit_event_group_overlap_label(inputs)
	if (locale === "es") return es_edit_event_group_overlap_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_overlap_label(inputs)
	if (locale === "ja") return ja_edit_event_group_overlap_label(inputs)
	if (locale === "hi") return hi_edit_event_group_overlap_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_overlap_label(inputs)
	return en_edit_event_group_overlap_label(inputs)
});